import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Authority} from '../authority.model';
import {AuthorityActions, AuthorityActionTypes} from '../actions/authority.actions';

export interface State extends EntityState<Authority> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<Authority> = createEntityAdapter<Authority>({
  selectId: authority => authority.acode
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: AuthorityActions
): State {
  switch (action.type) {
    case AuthorityActionTypes.GetAllAuthoritys: {
      return {...state, Loaded: false, Loading: true};
    }

    case AuthorityActionTypes.AddAuthority: {
      return adapter.addOne(action.payload.authority, state);
    }

    case AuthorityActionTypes.UpsertAuthority: {
      return adapter.upsertOne(action.payload.authority, state);
    }

    case AuthorityActionTypes.AddAuthoritys: {
      return adapter.addMany(action.payload.authoritys, state);
    }

    case AuthorityActionTypes.UpsertAuthoritys: {
      return adapter.upsertMany(action.payload.authoritys, state);
    }

    case AuthorityActionTypes.UpdateAuthority: {
      return adapter.updateOne(action.payload.authority, state);
    }

    case AuthorityActionTypes.UpdateAuthoritys: {
      return adapter.updateMany(action.payload.authoritys, state);
    }

    case AuthorityActionTypes.DeleteAuthority: {
      return adapter.removeOne(action.payload.id, state);
    }

    case AuthorityActionTypes.DeleteAuthoritys: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case AuthorityActionTypes.LoadAuthoritys: {
      adapter.removeAll(state);
      return adapter.setAll(action.payload.authoritys, {...state, Loaded: true, Loading: false});
    }

    case AuthorityActionTypes.ClearAuthoritys: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
